module.exports = __webpack_public_path__ + "img/xbm.e3e21301.jpg";